import { useState, useEffect } from 'react'
import { useServerSent } from '../ServerSent'
import { SSEData } from '../ServerSent/types'
import { SSE_URL } from '../../Config/SSE/sse.config'
import { GAMES_STATS_SSE_ENABLED } from '../../Constants/season'

type UseGameSSEReturn = {
  setShouldConnect: (shouldConnect: boolean) => void
  sseConnected: boolean
  fetchFails: number
  promptRefresh: boolean
  setFetchFails: (fails: number | ((prev: number) => number)) => void
  setPromptRefresh: (refresh: boolean) => void
}

export const useGameSSE = (
  onUpdate: (data: SSEData) => void
): UseGameSSEReturn => {
  const [shouldConnect, setShouldConnect] = useState(false)
  const [sseConnected, setSSEConnected] = useState(false)
  const [fetchFails, setFetchFails] = useState(0)
  const [promptRefresh, setPromptRefresh] = useState(false)

  const {
    data: sseData,
    error: sseError,
    isConnected,
    connect: connectSSE,
    disconnect: disconnectSSE,
  } = useServerSent<SSEData>({
    url: SSE_URL,
  })

  useEffect(() => {
    if (!GAMES_STATS_SSE_ENABLED) return
    if (shouldConnect && !isConnected) {
      connectSSE()
      setSSEConnected(true)
      return
    }
    if (!shouldConnect && isConnected) {
      disconnectSSE()
      setSSEConnected(false)
    }
  }, [shouldConnect, isConnected])


  useEffect(() => {
    if (!GAMES_STATS_SSE_ENABLED) return
    if (sseData) {
      onUpdate(sseData)
    }
  }, [sseData, onUpdate])

  useEffect(() => {
    if (!GAMES_STATS_SSE_ENABLED) return
    if (sseError) {
      console.error('SSE Error:', sseError)
      setFetchFails((prev) => prev + 1)
    }
  }, [sseError])

  useEffect(() => {
    if (!GAMES_STATS_SSE_ENABLED) return
    if (fetchFails >= 5) {
      console.error('Too many fetch failures, prompting refresh...')
      setPromptRefresh(true)
    }
  }, [fetchFails])

  useEffect(() => {
    if (!GAMES_STATS_SSE_ENABLED) return
    return () => {
      if (isConnected) {
        disconnectSSE()
      }
    }
  }, [])

  return {
    setShouldConnect,
    sseConnected,
    fetchFails,
    promptRefresh,
    setFetchFails,
    setPromptRefresh,
  }
}

export default useGameSSE
